import { searchConstants as C, initialSearchState } from '../_constants';

export function search(state = initialSearchState, action) {
  switch (action.type) {
    case C.RUN_REQUEST:
      return { ...state, q: action.q, kinds: action.kinds, seq: action.seq, status: 'loading', error: null };
    case C.RUN_SUCCESS:
      if (action.seq !== state.seq) return state; // a newer request superseded this one
      return {
        ...state,
        status: 'done',
        total: action.total,
        ids: action.results.map((r) => r.item_id),
        byId: Object.fromEntries(action.results.map((r) => [r.item_id, r])),
      };
    case C.RUN_FAILURE:
      if (action.seq !== state.seq) return state;
      return { ...state, status: 'error', error: action.error };
    case C.SET_KINDS:
      return { ...state, kinds: action.kinds };
    case C.CLEAR:
      return { ...initialSearchState, seq: state.seq + 1 };
    default:
      return state;
  }
}
